var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":_vm.size + 'px',"fill":_vm.color,"viewBox":"0 0 451.827 451.827"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M225.922,0C101.351,0,0.004,101.347,0.004,225.917s101.347,225.909,225.917,225.909    c124.554,0,225.901-101.347,225.901-225.909C451.823,101.347,350.476,0,225.922,0z"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }